import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Link } from 'react-router-dom';
import { ALL_UNIQUE_AVATAR_PROPERTIES } from '../../../types/uniqueAvatarTypes';
import { AvatarShowcase } from './avatarShowcase';
const AVATAR_IMAGE_URLS = [
    ALL_UNIQUE_AVATAR_PROPERTIES.queen.url,
    ALL_UNIQUE_AVATAR_PROPERTIES.monkey.url,
    ALL_UNIQUE_AVATAR_PROPERTIES.sentinel.url,
    ALL_UNIQUE_AVATAR_PROPERTIES.wizard.url,
    ALL_UNIQUE_AVATAR_PROPERTIES.mystic.url,
    ALL_UNIQUE_AVATAR_PROPERTIES.lizard.url
];
export const UniqueAvatarShowcase = () => (_jsx(AvatarShowcase, { title: 'Unique Avatars!', subTitle: _jsxs(_Fragment, { children: [_jsx(Link, { to: '/guide/unique-avatars', children: "Win avatars" }), " that no one else can have!"] }), imageUrls: AVATAR_IMAGE_URLS, isAvatarOnLeft: false }));
